import { createContext } from "react";
export const CustomComponents = createContext<{ [key: string]: {displayName: string, component: React.Component}}>({});
export default CustomComponents